var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1318_125998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.65C10.825 0.925 9.475 0.5 8 0.5V1.65H12Z",
    fill: "#ED4C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 2.7999H13.4C12.975 2.3749 12.5 1.9749 12 1.6499H8V2.7999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3.9498H14.325C14.05 3.5248 13.75 3.1498 13.425 2.7998H8V3.9498Z",
    fill: "#ED4C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.1002H14.925C14.75 4.7002 14.55 4.3002 14.325 3.9502H8V5.1002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6.2501H15.3C15.2 5.8501 15.075 5.4751 14.925 5.1001H8V6.2501Z",
    fill: "#ED4C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7.4249H15.475C15.45 7.0249 15.375 6.6499 15.3 6.2749H8V7.4249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.475 7.4248H8V7.9998H0.5C0.5 8.1998 0.5 8.3748 0.525 8.5748H15.475C15.5 8.3748 15.5 8.1998 15.5 7.9998C15.5 7.7998 15.5 7.5998 15.475 7.4248Z",
    fill: "#ED4C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.700391 9.7252H15.3004C15.4004 9.3502 15.4504 8.9752 15.4754 8.5752H0.525391C0.550391 8.9502 0.600391 9.3502 0.700391 9.7252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0752 10.8751H14.9252C15.0752 10.5001 15.2002 10.1251 15.3002 9.7251H0.700195C0.800195 10.1251 0.925195 10.5001 1.0752 10.8751Z",
    fill: "#ED4C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6752 12.025H14.3252C14.5502 11.65 14.7502 11.275 14.9252 10.875H1.0752C1.2502 11.275 1.4502 11.65 1.6752 12.025Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5748 13.1749H13.4248C13.7498 12.8249 14.0748 12.4249 14.3248 12.0249H1.6748C1.9248 12.4499 2.2498 12.8249 2.5748 13.1749Z",
    fill: "#ED4C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9752 14.3248H12.0252C12.5502 13.9998 13.0002 13.5998 13.4252 13.1748H2.5752C3.0002 13.6248 3.4752 13.9998 3.9752 14.3248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99961 15.5002C9.47461 15.5002 10.8496 15.0752 12.0246 14.3252H3.97461C5.14961 15.0752 6.52461 15.5002 7.99961 15.5002Z",
    fill: "#ED4C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 1.65C3.475 1.975 3 2.375 2.575 2.8C2.225 3.15 1.925 3.55 1.675 3.95C1.45 4.325 1.225 4.7 1.075 5.1C0.925 5.475 0.8 5.85 0.7 6.25C0.6 6.625 0.55 7 0.525 7.4C0.5 7.6 0.5 7.8 0.5 8H8V0.5C6.525 0.5 5.175 0.925 4 1.65Z",
    fill: "#428BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.24961 0.75L6.37461 1.125H6.74961L6.44961 1.375L6.54961 1.75L6.24961 1.525L5.94961 1.75L6.04961 1.375L5.74961 1.125H6.12461L6.24961 0.75ZM7.24961 2.25L7.37461 2.625H7.74961L7.44961 2.875L7.54961 3.25L7.24961 3.025L6.94961 3.25L7.04961 2.875L6.74961 2.625H7.12461L7.24961 2.25ZM5.24961 2.25L5.37461 2.625H5.74961L5.44961 2.875L5.54961 3.25L5.24961 3.025L4.94961 3.25L5.04961 2.875L4.74961 2.625H5.12461L5.24961 2.25ZM6.24961 3.75L6.37461 4.125H6.74961L6.44961 4.375L6.54961 4.75L6.24961 4.525L5.94961 4.75L6.04961 4.375L5.74961 4.125H6.12461L6.24961 3.75ZM4.24961 3.75L4.37461 4.125H4.74961L4.44961 4.375L4.54961 4.75L4.24961 4.525L3.94961 4.75L4.04961 4.375L3.74961 4.125H4.12461L4.24961 3.75ZM2.24961 3.75L2.37461 4.125H2.74961L2.44961 4.375L2.54961 4.75L2.24961 4.525L1.94961 4.75L2.04961 4.375L1.74961 4.125H2.12461L2.24961 3.75ZM7.24961 5.25L7.37461 5.625H7.74961L7.44961 5.875L7.54961 6.25L7.24961 6.025L6.94961 6.25L7.04961 5.875L6.74961 5.625H7.12461L7.24961 5.25ZM5.24961 5.25L5.37461 5.625H5.74961L5.44961 5.875L5.54961 6.25L5.24961 6.025L4.94961 6.25L5.04961 5.875L4.74961 5.625H5.12461L5.24961 5.25ZM3.24961 5.25L3.37461 5.625H3.74961L3.44961 5.875L3.54961 6.25L3.24961 6.025L2.94961 6.25L3.04961 5.875L2.74961 5.625H3.12461L3.24961 5.25ZM6.24961 6.75L6.37461 7.125H6.74961L6.44961 7.375L6.54961 7.75L6.24961 7.525L5.94961 7.75L6.04961 7.375L5.74961 7.125H6.12461L6.24961 6.75ZM4.24961 6.75L4.37461 7.125H4.74961L4.44961 7.375L4.54961 7.75L4.24961 7.525L3.94961 7.75L4.04961 7.375L3.74961 7.125H4.12461L4.24961 6.75ZM2.24961 6.75L2.37461 7.125H2.74961L2.44961 7.375L2.54961 7.75L2.24961 7.525L1.94961 7.75L2.04961 7.375L1.74961 7.125H2.12461L2.24961 6.75ZM2.94961 3.25L3.24961 3.025L3.54961 3.25L3.42461 2.875L3.72461 2.625H3.34961L3.24961 2.25L3.12461 2.625H2.77461L3.07461 2.85L2.94961 3.25ZM0.949609 6.25L1.24961 6.025L1.54961 6.25L1.42461 5.875L1.72461 5.625H1.37461L1.24961 5.25L1.12461 5.625H0.874609C0.874609 5.65 0.849609 5.675 0.849609 5.7L1.04961 5.85L0.949609 6.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1318_125998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUs);
export default __webpack_public_path__ + "static/media/flag-us.8d11bdc000807644ca2968a9fdd5d751.svg";
export { ForwardRef as ReactComponent };